import graphql__d48b72286340fd86b1fe from "./__generated__/UpdatePersonContactDialog_contact.graphql.ts";
import graphql__d8b555db10b53ba3bd5d from "./__generated__/UpdatePersonContactDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useIntl} from "react-intl";

type UpdatePersonContactDialogProps = {
    queryRef: any
    handleCloseDialog: () => {}
}

const UpdatePersonContactDialog: React.FC<UpdatePersonContactDialogProps> = (props) => {
    const intl = useIntl();

    const contact = useFragment(
        graphql__d48b72286340fd86b1fe,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();
    
    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__d8b555db10b53ba3bd5d,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToUpdatePersonContact'})
            }
        )
    }

    const initialValues = {
        id: contact.id,
        salutation: contact.salutation,
        givenName: contact.givenName,
        familyName: contact.familyName,
        emailAddress: contact.emailAddress,
        phoneNumber: contact.phoneNumber ?? undefined
    }

    const validationSchema = yup.object().shape({
        salutation: yup.string()
            .required(intl.formatMessage({id: 'validation.field.required'})),
        givenName: yup.string()
            .max(255, intl.formatMessage({id: 'validation.field.nameTooLong'}))
            .matches(/^[-+&\p{L}\p{P}\d .]{2,255}$/u, intl.formatMessage({id: 'validation.field.nameContainsInvalidCharacters'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        familyName: yup.string()
            .max(255, intl.formatMessage({id: 'validation.field.nameTooLong'}))
            .matches(/^[-+&\p{L}\p{P}\d .]{2,255}$/u, intl.formatMessage({id: 'validation.field.nameContainsInvalidCharacters'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        emailAddress: yup.string()
            .max(255, intl.formatMessage({id: 'validation.field.emailAddressTooLong'}))
            .email(intl.formatMessage({id: 'validation.field.emailAddressInvalid'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        phoneNumber: yup.string() // The ITU E.164 states that phone numbers around the globe are recommended to not be longer than 15 digits, but we allow more digits to be safe
            .max(20, intl.formatMessage({id: 'validation.field.phoneNumberTooLong'}))
            .matches(/^(\+(?:[0-9] ?){6,19}[0-9])?$/, intl.formatMessage({id: 'validation.field.phoneNumberInvalid'}))
            .nullable()
    });

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.UpdatePersonContactDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.update'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.salutation'})}</Label>
                    <Field name="salutation" as="select">
                        <option value="MR">{intl.formatMessage({id: 'contact.salutation.mr'})}</option>
                        <option value="MRS">{intl.formatMessage({id: 'contact.salutation.mrs'})}</option>
                        <option value="MX">{intl.formatMessage({id: 'contact.salutation.mx'})}</option>
                        <option value="HELLO">{intl.formatMessage({id: 'contact.salutation.hello'})}</option>
                    </Field>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.givenName'})}</Label>
                    <Field name="givenName" type="text" placeholder={intl.formatMessage({id: 'dialog.UpdatePersonContactDialog.givenNamePlaceholder'})} autoFocus={true}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.familyName'})}</Label>
                    <Field name="familyName" type="text" placeholder={intl.formatMessage({id: 'dialog.UpdatePersonContactDialog.familyNamePlaceholder'})}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.emailAddress'})}</Label>
                    <Field name="emailAddress" type="text" placeholder={intl.formatMessage({id: 'dialog.UpdatePersonContactDialog.emailPlaceholder'})}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.phoneNumber'})}</Label>
                    <Field name="phoneNumber" type="text" placeholder={intl.formatMessage({id: 'dialog.UpdatePersonContactDialog.phonePlaceholder'})}/>
                </Row>
            </Section>
        </FormDialog>
    )
}
export default UpdatePersonContactDialog;
